import * as Actions from 'store/actions/app/products.actions'

const initialState = {
  searching_products: false,
  searched_products: [],

  loading_products_by_supplier: false,
  products_by_supplier: [],

  downloading_product_prices_list_excel: false,
}

const productsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SEARCH_PRODUCTS: {
      return {
        ...state,
        searching_products: action.payload.loading ?? false,
        searched_products: action.payload.data ?? state.searched_products
      }
    }
    case Actions.GET_PRODUCTS_BY_SUPPLIER_ID: {
      return {
        ...state,
        loading_products_by_supplier: action.payload.loading ?? false,
        products_by_supplier: action.payload.data ?? state.products_by_supplier
      }
    }
    case Actions.DOWNLOADING_PRODUCT_PRICES_LIST_EXCEL: {
      return {
        ...state,
        downloading_product_prices_list_excel: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default productsReducer
